import IqosSuperBrand from "./IqosSuperBrand";
export default IqosSuperBrand;